import React, { useState,useCallback } from 'react';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import styles from 'components/settings.module.scss'
import cn from 'classnames';
import CustomDropDown from './CustomDropDown';
import { useSelector, useDispatch } from "react-redux";
import { fetchSiteList, getSiteList } from 'redux/siteSlice';
import Mysettinglist from './my_settings/mysettinglist';

function Settings() {
	const siteListData = useSelector(getSiteList);
	const dispatch = useDispatch();
	const [siteMultiSelect, setSiteMultiSelect] = useState(siteListData);
	const [tabIndex, setTabIndex] = useState(0);
	const [selectedList, selectedItem] = useState();
	const [outerSideClick, setOuterSideClick] = useState(true);

	const filterData = useCallback((data) => {
		selectedItem(data)
	  }, []);

	window.addEventListener('click', function (e) {
		if (e && e.target && document.getElementById('settingClickbox')?.contains(e.target)) {
			setOuterSideClick(true)
		} else {
			setOuterSideClick(false)
		}
	});
	

	return (

		<div className={cn('Settings', styles.block, styles.block_layout)}>
			<div className={cn(styles.flex, styles.flex_layout)}>
				<Header page_name='My Settings'></Header>

				<div className={cn(styles.block5, styles.block5_layout)}>
					<div className={cn(styles.block5_item)}>
						<h3 className={cn(styles.subtitle, styles.subtitle_layout)}>{'Site:'}</h3>
					</div>
					<div className={cn(styles.block5_spacer)} />
					<div id='settingClickbox' className={cn(styles.block5_item1)}>
						<CustomDropDown settingClickCheck={outerSideClick} dropdownData={siteMultiSelect} chargerCallback={filterData} />
						{/* </div> */}
					</div>
					<div className={cn(styles.block5_spacer1)} />
					<div className={cn(styles.block5_item2)}>
					  <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>{'Total Drivers: 00'}</h3>
					</div>
					<div className={cn(styles.block5_spacer1)} />
					<div className={cn(styles.block5_item2)}>
					  <span className={cn(styles.subtitle,styles.searchTitle, styles.subtitle_layout)}>{'Search:'}</span>
					 
					</div>
					<div className={cn(styles.block5_item2)}>
				     	<input className={cn(styles.searchBox)} type="text" />
						 <img style={{'width':'27px','position':'absolute','top':'1px','right':'2px'}} src={require('assets/search.svg').default} />
					</div>
				</div>



				<div className={cn(styles.group, styles.group_layout1,styles.settingTab)}>
					<div className={cn(styles.block4, styles.block4_layout)}>
						<Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
							<TabList>
								<Tab>My Drivers</Tab>
								<Tab>My Fleet Setup</Tab>
								<Tab>My Fleet</Tab>
							</TabList>

							<TabPanel>
								<div className={cn(styles.tabContainer)}>
								<Mysettinglist/>
								</div>
							
							</TabPanel>
							<TabPanel>
							<div className={cn(styles.tabContainer)}></div>

							</TabPanel>
							<TabPanel>
							<div className={cn(styles.tabContainer)}></div>

							</TabPanel>
							<TabPanel>
							<div className={cn(styles.tabContainer)}></div>

							</TabPanel>

						</Tabs>
					</div>
					<div className={cn(styles.addMySettings)}>
						<span className={cn(styles.btnaddDriver)}>Add Driver</span>
					</div>
				</div>


				<Footer></Footer>

			</div>
		</div>
	)
}
// const settings = props => (
// 	<div>This is a component called settings.</div>
// );

// // todo: Unless you need to use lifecycle methods or local state,
// // write your component in functional form as above and delete
// // this section. 
// // class settings extends React.Component {
// //   render() {
// //     return <div>This is a component called settings.</div>;
// //   }
// // }

// const settingsPropTypes = {
// 	// always use prop types!
// };

// settings.propTypes = settingsPropTypes;

export default Settings;
